import { CircleMarker, LatLng } from 'leaflet';
import { antPath } from 'leaflet-ant-path';
import { GlobalStateResume, GlobalStateType, RAT } from '@mocca-technologies/model';

export class OperationPathModel implements OperationPathLayers {
    route: antPath;
    startMarker: CircleMarker;
    endMarker: CircleMarker;

    constructor(flightPath: LatLng[]) {
        if (flightPath) {
            this.route = antPath(flightPath, {
                delay: 1200,
                dashArray: [50, 80],
                weight: 6
            });

            const firstPoint = flightPath[0];
            this.startMarker = new CircleMarker(firstPoint, {
                fillColor: 'Aquamarine',
                fillOpacity: 1,
                radius: 6
            }).bindTooltip('Start');

            const lastPoint = flightPath[flightPath.length - 1];
            this.endMarker = new CircleMarker(lastPoint, {
                fillColor: 'Tomato',
                fillOpacity: 1,
                radius: 6
            }).bindTooltip('End');
        }
    }
}

export type OperationPathLayers = {
    route: antPath;
    startMarker: CircleMarker;
    endMarker: CircleMarker;
};

export class OperationUtils {
    /**
     * Checks if:
     * - State is 0 (POSITION_BIT)
     * - State is 4 (GSM_BIT)
     * - fixType is greater or equal to 2
     * @param globalStateResume object to be filtered
     * @returns
     */
    static filterResponse(globalStateResume: GlobalStateResume): boolean {
        return !!(
            GlobalStateType.getState(globalStateResume.state, GlobalStateType.POSITION_BIT) &&
            globalStateResume.fixType >= 2
        );
    }

    /**
     * Edit the current object to fill properties depending the RAT type.
     * @param globalStateResume object to be mapped
     * @returns
     */
    static projectResponse(globalStateResume: GlobalStateResume): GlobalStateResume {
        // Altitude
        globalStateResume.altitude = +globalStateResume.altitude.toFixed(1);
        // Signal
        switch (globalStateResume.RAT) {
            case RAT.Unknown:
                globalStateResume.rssi_unknown = -110;
                globalStateResume.rssi_gsm = null;
                globalStateResume.rssi_umts = null;
                globalStateResume.rssi_wcdma = null;
                globalStateResume.rssi_lte = null;
                globalStateResume.rssi_cdma = null;
                break;

            case RAT.GSM:
                globalStateResume.rssi_gsm =
                    globalStateResume.rssi === 0 ? -110 : globalStateResume.rssi;
                globalStateResume.rssi_unknown = null;
                globalStateResume.rssi_umts = null;
                globalStateResume.rssi_wcdma = null;
                globalStateResume.rssi_lte = null;
                globalStateResume.rssi_cdma = null;
                break;

            case RAT.UMTS:
                globalStateResume.rssi_umts =
                    globalStateResume.rssi === 0 ? -110 : globalStateResume.rssi;
                globalStateResume.rssi_unknown = null;
                globalStateResume.rssi_gsm = null;
                globalStateResume.rssi_wcdma = null;
                globalStateResume.rssi_lte = null;
                globalStateResume.rssi_cdma = null;
                break;

            case RAT.WCDMA:
                globalStateResume.rssi_wcdma =
                    globalStateResume.rssi === 0 ? -110 : globalStateResume.rssi;
                globalStateResume.rssi_unknown = null;
                globalStateResume.rssi_gsm = null;
                globalStateResume.rssi_umts = null;
                globalStateResume.rssi_lte = null;
                globalStateResume.rssi_cdma = null;
                break;

            case RAT.LTE:
                globalStateResume.rssi_lte =
                    globalStateResume.rssi === 0 ? -110 : globalStateResume.rssi;
                globalStateResume.rssi_unknown = null;
                globalStateResume.rssi_gsm = null;
                globalStateResume.rssi_umts = null;
                globalStateResume.rssi_wcdma = null;
                globalStateResume.rssi_cdma = null;
                break;

            case RAT.CDMA:
                globalStateResume.rssi_cdma =
                    globalStateResume.rssi === 0 ? -110 : globalStateResume.rssi;
                globalStateResume.rssi_unknown = null;
                globalStateResume.rssi_gsm = null;
                globalStateResume.rssi_umts = null;
                globalStateResume.rssi_wcdma = null;
                globalStateResume.rssi_lte = null;
                break;
        }

        return globalStateResume;
    }
}
